//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import * as merchant from '@/api/merchant';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
export default {
  name: 'index',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    merIdChecked: {
      type: [Number, String, Boolean],
      default: null
    }
  },
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          if (this.scrollHeight - this.scrollTop < this.clientHeight + 1) {
            binding.value();
          }
        }, {
          passive: true
        });
      }
    }
  },
  watch: {
    merIdChecked: function merIdChecked(n) {
      this.merId = n ? n : null;
    }
  },
  data: function data() {
    return {
      merchantList: [],
      merId: this.merIdChecked,
      loading: false,
      search: {
        limit: 10,
        page: 1,
        keywords: ''
      }
    };
  },
  mounted: function mounted() {
    if (checkPermi(['platform:merchant:page:list'])) this.getMerList();
  },
  methods: {
    // 下拉加载更多
    selectLoadMore: function selectLoadMore() {
      this.search.page = this.search.page + 1;
      if (this.search.page > this.totalPage) return;
      this.getMerList(); // 请求接口
    },
    // 远程搜索
    remoteMethod: function remoteMethod(query) {
      var _this = this;
      this.loading = true;
      this.search.keywords = query;
      this.search.page = 1;
      this.merchantList = [];
      setTimeout(function () {
        _this.loading = false;
        _this.getMerList(); // 请求接口
      }, 200);
    },
    // 列表
    getMerList: function getMerList() {
      var _this2 = this;
      merchant.merchantListApi(this.search).then(function (res) {
        _this2.totalPage = res.totalPage;
        _this2.total = res.total;
        _this2.merchantList = _this2.merchantList.concat(res.list);
      });
    },
    onChangeMerId: function onChangeMerId() {
      this.$emit('getMerId', this.merId);
    }
  }
};